var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 47,
    viewBox: "0 0 45 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.958055 23.4967C0.957001 27.3255 1.95208 31.0641 3.84421 34.3593L0.7771 45.6181L12.2374 42.597C15.4072 44.3319 18.9587 45.2409 22.5677 45.2411H22.5772C34.4913 45.2411 44.1896 35.4942 44.1947 23.5139C44.197 17.7086 41.9504 12.2496 37.8685 8.14262C33.7873 4.03597 28.3595 1.77316 22.5763 1.77051C10.6608 1.77051 0.96315 11.517 0.958231 23.4967",
    fill: "url(#paint0_linear_1094_934)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.187983 23.4899C0.186753 27.4565 1.2175 31.3287 3.17709 34.7419L0 46.4043L11.8712 43.2749C15.1421 45.0679 18.8249 46.0132 22.5722 46.0146H22.5819C34.9234 46.0146 44.9702 35.9171 44.9754 23.5079C44.9775 17.494 42.6501 11.8388 38.4224 7.58469C34.1942 3.33108 28.5722 0.986848 22.5819 0.984375C10.2382 0.984375 0.192902 11.0806 0.187983 23.4899ZM7.25774 34.1541L6.81448 33.4467C4.95116 30.468 3.96768 27.0258 3.96908 23.4913C3.97295 13.177 12.3222 4.78546 22.5889 4.78546C27.5608 4.78758 32.2333 6.73616 35.7477 10.2716C39.262 13.8074 41.1957 18.5075 41.1945 23.5065C41.1899 33.8208 32.8405 42.2134 22.5819 42.2134H22.5745C19.2342 42.2116 15.9582 41.3097 13.1012 39.6054L12.4213 39.2001L5.37667 41.057L7.25774 34.1541Z",
    fill: "url(#paint1_linear_1094_934)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9837 14.0813C16.5645 13.1446 16.1234 13.1257 15.7247 13.1093C15.3983 13.0951 15.0252 13.0962 14.6524 13.0962C14.2792 13.0962 13.6729 13.2373 13.1604 13.7999C12.6474 14.363 11.2019 15.7238 11.2019 18.4914C11.2019 21.2592 13.207 23.9339 13.4865 24.3096C13.7664 24.6846 17.3574 30.5459 23.0447 32.8007C27.7713 34.6746 28.7332 34.3019 29.759 34.2079C30.785 34.1143 33.0696 32.8475 33.5357 31.5339C34.0022 30.2205 34.0022 29.0947 33.8623 28.8594C33.7225 28.625 33.3493 28.4842 32.7898 28.203C32.23 27.9217 29.4791 26.5607 28.9663 26.373C28.4533 26.1854 28.0803 26.0918 27.7072 26.655C27.334 27.2174 26.2625 28.4842 25.9359 28.8594C25.6097 29.2354 25.2831 29.2822 24.7237 29.0009C24.1638 28.7186 22.3618 28.1253 20.2239 26.2091C18.5605 24.7179 17.4375 22.8766 17.1111 22.3133C16.7847 21.7509 17.0761 21.446 17.3567 21.1657C17.6081 20.9137 17.9164 20.5088 18.1965 20.1805C18.4755 19.852 18.5686 19.6176 18.7551 19.2424C18.9419 18.8669 18.8484 18.5384 18.7088 18.257C18.5686 17.9756 17.4812 15.1935 16.9837 14.0813Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1094_934",
    x1: 2171.66,
    y1: 4386.53,
    x2: 2171.66,
    y2: 1.77051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1094_934",
    x1: 2248.77,
    y1: 4542.98,
    x2: 2248.77,
    y2: 0.984375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7cc46124696753e0714515a8c89fbf24.svg";
export { ForwardRef as ReactComponent };